import VariantWrapper from "./VariantWrapper";
import ServiceHubPosterChapterData from '../PosterChapter.interface';

export default function LayoutVariant6(props: ServiceHubPosterChapterData) {
    return (
        <VariantWrapper data={props}>{null}</VariantWrapper>
    )
}
